// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".components-products-documents-item-xyjrq{display:grid;grid-gap:16px;grid-template-columns:48px 1fr}.components-products-documents-item-xyjrq:not(:last-child){margin-bottom:24px}.components-products-documents-icon-byggu{height:48px;width:48px}.components-products-documents-link-bakmx{text-decoration:none}.components-products-documents-link-bakmx:hover{text-decoration:underline}.components-products-documents-size-bgjaj{color:#777;font-size:12px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": "components-products-documents-item-xyjrq",
	"icon": "components-products-documents-icon-byggu",
	"link": "components-products-documents-link-bakmx",
	"size": "components-products-documents-size-bgjaj"
};
module.exports = ___CSS_LOADER_EXPORT___;
